import { combineReducers } from "redux";
import { LOGOUT } from "store/types";
import loadingReducer from "./loadingReducer";
import authReducer from "./authReducer";
import nftReducer from "./nftReducer";
import userReducer from "./userReducer";
import txnReducer from "./txnRecucer";
import landingReducer from "./landingReducer";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    nfts: nftReducer,
    users: userReducer,
    txns: txnReducer,
    landing: landingReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
